import React, { Component } from 'react';
import { CapaLlegendaSVG24 } from './CapaLlegendaIconsElement';

export class CapaLlegendaVisibilityIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isButtonHovered: false
    };
  }

  render = () => {
    //default case: visible
    let svgPath = (
      <path d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z" />
    );

    if (this.props.type === 'has-scale')
      svgPath = (
        <>
          <path d="M12,5.2c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S10.3,5.2,12,5.2 M12,0.7c5,0,9.3,3.1,11,7.5c-1.7,4.4-6,7.5-11,7.5 S2.7,12.6,1,8.2C2.7,3.8,7,0.7,12,0.7 M3.2,8.2c1.6,3.4,5.1,5.5,8.8,5.5s7.2-2.1,8.8-5.5c-1.6-3.4-5.1-5.5-8.8-5.5S4.8,4.9,3.2,8.2z	"></path>
          <rect x="0.3" y="19.1" width="7.7" height="4.7"></rect>
          <rect x="16" y="19.1" width="7.7" height="4.7"></rect>
          <rect x="0.3" y="18.8" width="23.5" height="0.6"></rect>
          <rect x="0.3" y="23.2" width="23.5" height="0.6"></rect>
        </>
      );
    else if (this.props.type === 'not-visible')
      svgPath = (
        <path d="M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z" />
      );
    else if (this.props.type === 'scale-not-visible')
      svgPath = (
        <>
          <rect x="0.3" y="19.1" width="7.7" height="4.7" />
          <rect x="16" y="19.1" width="7.7" height="4.7" />
          <rect x="0.3" y="18.8" width="23.5" height="0.6" />
          <rect x="0.3" y="23.2" width="23.5" height="0.6" />
          <path d="M2,1.4l1.3-1.3L20,16.8l-1.3,1.3L15.6,15c-1.1,0.4-2.4,0.6-3.6,0.6c-5,0-9.3-3.1-11-7.5c0.7-1.8,1.8-3.3,3.2-4.5L2,1.4   M12,5.1c1.7,0,3,1.3,3,3c0,0.4-0.1,0.7-0.2,1L11,5.3C11.4,5.1,11.7,5.1,12,5.1 M12,0.6c5,0,9.3,3.1,11,7.5c-0.8,2.1-2.2,3.9-4,5.2  l-1.4-1.4c1.4-0.9,2.5-2.2,3.2-3.8c-1.6-3.4-5.1-5.5-8.8-5.5c-1.1,0-2.2,0.2-3.2,0.5L7.3,1.6C8.8,0.9,10.4,0.6,12,0.6 M3.2,8.1  c1.6,3.4,5.1,5.5,8.8,5.5c0.7,0,1.4-0.1,2-0.2l-2.3-2.3C10.3,11,9.1,9.8,9,8.4L5.6,5C4.7,5.8,3.8,6.9,3.2,8.1z" />
        </>
      );
    return (
      <CapaLlegendaSVG24
        onMouseEnter={() => this.setState({ isButtonHovered: true })}
        onMouseLeave={() => this.setState({ isButtonHovered: false })}
        fontSizeEnabled={this.props.fontSizeEnabled}
        viewBox="0 0 24 24"
        fill={
          window.innerWidth > 768
            ? this.state.isButtonHovered
              ? '#febf00'
              : this.props.layer && !this.props.layer.isOnRange()
              ? '#666666'
              : 'white'
            : 'white'
        }
        margin="0px"
        filter={this.state.isButtonHovered ? 'drop-shadow(0px 0px 6px #febf00dd)' : 'none'}>
        {svgPath}
      </CapaLlegendaSVG24>
    );
  };
}
